function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M23.344 10.087L17.001.575a1.779 1.779 0 00-1.153-.576 1.311 1.311 0 00-1.147.576l-6.34 9.51H1.442a1.361 1.361 0 00-1.441 1.443v.432l3.6 13.4a2.937 2.937 0 002.74 2.162h18.732a2.777 2.777 0 002.738-2.161l3.6-13.4v-.432a1.361 1.361 0 00-1.441-1.441zm-11.816 0l4.323-6.34 4.323 6.34zm4.323 11.527a2.882 2.882 0 112.882-2.882 2.89 2.89 0 01-2.882 2.882z",
  "data-name": "Path 2",
  fill: "#fff"
});

var SvgBasketFill = function SvgBasketFill(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 31.412 27.522"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/basketFill.237a35f6.svg";
export { SvgBasketFill as ReactComponent };